import { Action } from '@ngrx/store';

import { Query } from '../../shared/models/query/query.model';
import { CustomerTab } from '../../../xena-tabs/shared/models/customer-tab.model';



export const UPDATE_QUERY = '[XENA] UPDATE_QUERY';
export const RESET_QUERY = '[XENA] RESET_QUERY';
export const SUBMIT_QUERY = '[XENA] SUBMIT_QUERY';
export const INIT_QUERY_TABS = '[XENA] INIT_QUERY_TABS';



export class UpdateQuery implements Action {
	readonly type = UPDATE_QUERY;

	constructor(public payload: Partial<Query>) {}
}

export class ResetQuery implements Action {
	readonly type = RESET_QUERY;
}

export class SubmitQuery implements Action {
	readonly type = SUBMIT_QUERY;

	constructor(public payload: Query) {}
}

export class InitQueryTabs implements Action {
	readonly type = INIT_QUERY_TABS;

	constructor(public payload: Array<CustomerTab>) {}
}

export type All
	= UpdateQuery
	| ResetQuery
	| SubmitQuery
	| InitQueryTabs;



// WEBPACK FOOTER //
// ./src/app/xena/core/state-management/actions/query.ts